var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigitalCertificate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4282 8.85379L36.4282 32.4252L33.5711 35.2824L33.5711 6.71094L36.4282 8.85379Z",
    fill: "#FF8165"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2855 28.1412C19.0569 25.8876 17.1794 24.1158 14.812 23.9138C13.9957 23.836 13.1631 23.836 12.3304 23.9138C9.96306 24.1313 8.0855 25.8876 7.85693 28.1412",
    stroke: "#A020FF",
    strokeWidth: 1.81818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3335 35.9961H11.6668C5.00016 35.9961 3.3335 34.3294 3.3335 27.6628V14.3294C3.3335 7.66276 5.00016 5.99609 11.6668 5.99609H28.3335C35.0002 5.99609 36.6668 7.66276 36.6668 14.3294V27.6628C36.6668 34.3294 35.0002 35.9961 28.3335 35.9961Z",
    stroke: "#081E54",
    strokeWidth: 1.36364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3335 14.332H31.6668",
    stroke: "#081E54",
    strokeWidth: 1.36364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20.9961H31.6667",
    stroke: "#081E54",
    strokeWidth: 1.36364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3335 27.6602H31.6668",
    stroke: "#081E54",
    strokeWidth: 1.36364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 19.8146C15.8326 19.8146 17.1832 18.464 17.1832 16.7979C17.1832 15.1319 15.8326 13.7812 14.1666 13.7812C12.5005 13.7812 11.1499 15.1319 11.1499 16.7979C11.1499 18.464 12.5005 19.8146 14.1666 19.8146Z",
    fill: "#B7CCFF",
    stroke: "#081E54",
    strokeWidth: 1.36364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 28.213C19.7668 25.7964 17.8502 23.8964 15.4335 23.6797C14.6002 23.5964 13.7502 23.5964 12.9002 23.6797C10.4835 23.913 8.56683 25.7964 8.3335 28.213",
    stroke: "#081E54",
    strokeWidth: 1.36364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalCertificate);
export default __webpack_public_path__ + "static/media/DigitalCertificate.d094fe7c002e99737f164181fad9e4f8.svg";
export { ForwardRef as ReactComponent };